export enum TubulacaoTipo {
  PVC = 'PVC',
  FERRO_CHUMBO = 'FERRO_CHUMBO',
}
